import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import {
  toggleMenu,
} from 'cityads-v3/actions/menu';

import {
  MENU_LINKS
} from 'cityads-v3/components/Header/HeaderToolbar';

import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from 'cityads-v3/components/Tooltip/Tooltip';

import KeyboardArrowLeftOutlinedIcon from '@material-ui/icons/KeyboardArrowLeftOutlined';
import KeyboardArrowRightOutlinedIcon from '@material-ui/icons/KeyboardArrowRightOutlined';

import classes from './Menu.scss';

@connect(state => ({
  language: state.language.language,
  docked: state.menu.docked,
  isMobile: state.app.isMobile,
}))
@withTranslation(['main'], { i18n, wait: false })
export default class MenuContentGuest extends Component {

  static propTypes = {
    language: PropTypes.string,
    docked: PropTypes.bool,
    isMobile: PropTypes.bool,
  }

  onToggleMenu = (open, docked = false) => () => this.props.dispatch(toggleMenu(open, docked));

  render() {
    const { language, t, docked, isMobile } = this.props;

    return (
      <List>

        {!isMobile && <ListItem
          button
          classes={{
            root: classes.menuItemLink
          }}
          onClick={this.onToggleMenu(false, !docked)}
        >
          <ListItemIcon>
            {docked ? <KeyboardArrowLeftOutlinedIcon /> : <KeyboardArrowRightOutlinedIcon />}
          </ListItemIcon>
        </ListItem>}

        {MENU_LINKS
          .filter(({ requireLanguage, requireLoggedIn, requireLoggedRole }) => {
            if ((requireLanguage && requireLanguage !== language) || requireLoggedIn) {
              return false;
            }
            return true;
          })
          .map(({ to, href, title, icon }, idx) => {
            const listItem = (
              <ListItem
                button
                key={idx}
                component={href ? 'a' : Link}
                href={href}
                to={to}
                onClick={this.onToggleMenu(false)}
                classes={{
                  root: classes.menuItemLink
                }}
              >
                <ListItemIcon>
                  <Icon>{icon}</Icon>
                </ListItemIcon>
                {(docked || isMobile) && <ListItemText primary={t(title)} />}
              </ListItem>
            );

            return docked ? listItem : (
              <Tooltip
                key={idx}
                isLight
                title={t(title)}
                placement="right"
              >
                {listItem}
              </Tooltip>
            );
          })
        }

      </List>
    );
  }

}
